import { useEffect, useState } from 'react';
import { CustomerPreview } from 'services';

export const useCustomerPreview = () => {
  const [isPending, setIsPending] = useState(true);
  const [isPreview, setIsPreview] = useState<boolean | null>(null);
  const [projectId, setProjectId] = useState<number | null>(null);

  useEffect(() => {
    CustomerPreview.isPreviewMode().then((result) => {
      if (!result[0]) {
        setIsPreview(false);
        setIsPending(false);

        return;
      }
      setProjectId(result[1]);
      setIsPreview(true);
      setIsPending(false);
    });
  }, []);

  return { isPreview, isPending, projectId };
};
